import classNames from 'classnames';
import {Typography} from 'components/Typography';
import React, {FC, useMemo} from 'react';
import style from './style.module.scss';
import {IDataAutotestProps} from 'core/types';

export interface IInputCaptionPublicProps {
    captionText?: string | React.ReactNode;
    errorText?: string;
}

export interface IProps extends IInputCaptionPublicProps {
    disabled?: boolean;
    className?: string;
}

export const InputCaption: FC<IProps & IDataAutotestProps> = ({
    className,
    captionText,
    errorText,
    disabled,
    dataAutotestTarget,
    dataAutotestTargetId,
}) => {
    const renderText = useMemo<IInputCaptionPublicProps['captionText']>(() => {
        if (errorText) {
            return errorText;
        }

        return captionText || '';
    }, [captionText, errorText]);

    return (
        <Typography
            className={classNames(style.inputCaption, className, {
                [style.inputCaptionError]: errorText,
                ['input-caption-error']: errorText,
                [style.inputCaptionDisabled]: disabled,
            })}
            data-autotest-target={dataAutotestTarget}
            data-autotest-target-id={dataAutotestTargetId}
            variant={'label-12-r'}
        >
            {renderText}
        </Typography>
    );
};
